import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {getErrorFromMessage} from "services/utils/utils";
import {notificationDeleteError, notificationDeleteSuccess} from "store/reducer/notifications/delete/reducer";

export function* notificationDeleteSaga() {
    try {
        yield call([api, api.deleteNotificationListApi]);
        yield put(notificationDeleteSuccess());
    } catch (e) {
        yield put(notificationDeleteError(getErrorFromMessage(e)))
    }
}